import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { LandingCarrusel } from '@/components/LandingCarrusel';
import { LandingMenu } from '@/components/LandingMenu';
import { LandingTestimonios } from '@/components/LandingTestimonios';

const API = process.env.REACT_APP_BACKEND_URL;
const WA = '50254307807';
const AZUL = '#1FA3E8';
const IMG = {
  heroPoster: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/lt9eqepc_dd45bcb8-5401-4fb5-9d40-23125cab0f97.jpeg',
  vidrioPoster: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/ycqsqd07_989f9d51-fb11-404e-a6d2-cc71d25898da.jpeg',
  soldadorCutout: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/um3w2yw3_25e61597-60d3-4883-b427-e678e3d9c3a9.jpeg',
  flyerMarca: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/svzrqaof_5b6ccd98-865e-4a49-88e2-b13291453525.jpeg',
  trabajoNoche: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/udwx2e0c_8241b4b3-8053-4173-9e2c-c0a99ed17ab3.jpeg',
  fotoEscalera: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/hu6euzcx_40d775fb-f91f-4d96-b010-26008da7ad18.jpeg',
  fotoVidrio: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/plz5boeh_0a820d5d-1a14-4c74-b28d-c313c0fb2d39.jpeg',
};

const DEPARTAMENTOS = ['Guatemala', 'Sacatepéquez', 'Chimaltenango', 'Escuintla', 'Santa Rosa', 'Sololá', 'Totonicapán', 'Quetzaltenango', 'Suchitepéquez', 'Retalhuleu', 'San Marcos', 'Huehuetenango', 'Quiché', 'Baja Verapaz', 'Alta Verapaz', 'Petén', 'Izabal', 'Zacapa', 'Chiquimula', 'Jalapa', 'Jutiapa', 'El Progreso'];

const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

export default function LandingPasamanos() {
  const [form, setForm] = useState({ nombre: '', telefono: '', departamento: '', detalles: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.post(`${API}/api/landing/track`, { producto: 'pasamanos_acero_inox' }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.telefono.trim() || !form.departamento) {
      toast.error('Completa tu nombre, teléfono y departamento');
      return;
    }
    try {
      setSending(true);
      const res = await axios.post(`${API}/api/landing/pasamanos/lead`, form);
      setDone(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error enviando, intenta de nuevo');
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif" }} className="min-h-screen bg-[#080B10] text-white">
      <Toaster position="top-center" richColors />

      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#080B10]/90 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <div>
            <p className="font-black tracking-tight text-lg leading-none">SOLUCIONES <span style={{ color: AZUL }}>ARQUITECTÓNICAS</span></p>
            <p className="text-[10px] text-white/50 tracking-[0.25em] uppercase">Grupo SACH · Guatemala</p>
          </div>
          <div className="flex items-center gap-2">
            <LandingMenu actual="/pasamanosaceroinox" />
            <a href={waLink('¡Hola! Vi la página de pasamanos de acero inoxidable y quiero una cotización 😊')}
              target="_blank" rel="noreferrer" data-testid="wa-header-btn"
              className="bg-[#25D366] hover:brightness-110 text-white text-sm font-bold px-4 py-2 rounded-full transition-all">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <img src={IMG.heroPoster} alt="Pasamanos de acero inoxidable" className="w-full h-[68vh] object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B10] via-[#080B10]/50 to-[#080B10]/30" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-6xl mx-auto px-4 pb-10 w-full">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Fabricación e instalación profesional</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] max-w-3xl">
              Pasamanos de <span style={{ color: AZUL }}>Acero Inoxidable</span> y Vidrio Templado
            </h1>
            <p className="text-white/70 text-base mt-4 max-w-xl">
              Seguridad y elegancia que dura toda la vida. Diseño a la medida, materiales certificados e instalación en todo el país.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#cotizar" data-testid="hero-cta"
                style={{ background: AZUL }}
                className="hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
                COTIZA GRATIS →
              </a>
              <a href={waLink('¡Hola! Quiero cotizar un pasamanos de acero inoxidable 😊')} target="_blank" rel="noreferrer"
                className="border border-white/25 hover:border-white/60 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors">
                Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Banner 18 años de experiencia */}
      <section style={{ background: AZUL }} className="text-white" data-testid="banner-experiencia">
        <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col sm:flex-row items-center gap-6">
          <p className="text-6xl sm:text-7xl font-black leading-none shrink-0">+18</p>
          <div>
            <p className="font-black text-xl sm:text-2xl leading-tight">AÑOS DE EXPERIENCIA</p>
            <p className="text-white/90 text-sm sm:text-base mt-1 font-medium">
              Confía tus proyectos en manos profesionales. Más de miles de metros de pasamanos instalados en Guatemala, El Salvador, Honduras y Costa Rica.
            </p>
          </div>
        </div>
      </section>

      {/* Sección 1: texto + imagen (calidad soldada) */}
      <section className="max-w-6xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Calidad en cada detalle</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Acabados soldados e integrados en <span style={{ color: AZUL }}>una sola pieza</span></h2>
          <p className="text-white/60 text-base mt-4">
            En Soluciones Arquitectónicas, todos nuestros acabados son cuidadosamente soldados e integrados para que queden en una sola pieza,
            lo que da una mayor estabilidad, seguridad y modernidad a tu hogar o negocio.
          </p>
          <ul className="mt-5 space-y-2 text-sm text-white/75">
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Vidrio templado de alta resistencia</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Acero inoxidable de la más alta calidad</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Diseño moderno y fabricación a la medida</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Instalación profesional con equipo propio</li>
          </ul>
        </div>
        <figure className="rounded-3xl overflow-hidden border border-white/10">
          <img src={IMG.vidrioPoster} alt="Pasamanos de acero inox y vidrio templado" className="w-full h-[420px] object-cover object-top" />
        </figure>
      </section>

      {/* Sección 2: imagen + texto (manos profesionales) */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <figure className="rounded-3xl overflow-hidden border border-white/10 order-1 md:order-none bg-white">
          <img src={IMG.soldadorCutout} alt="Soldador profesional trabajando pasamanos" className="w-full h-[420px] object-cover object-top" />
        </figure>
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">¡Somos Profesionales!</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">No arriesgues tu inversión en <span style={{ color: AZUL }}>manos inexpertas</span></h2>
          <p className="text-white/60 text-base mt-4">
            Nuestro equipo de soldadores e instaladores certificados trabaja con los más altos estándares.
            Cada proyecto es supervisado de principio a fin para garantizar un acabado impecable y seguro.
          </p>
          <p className="text-white/60 text-base mt-3">
            Por eso miles de familias y empresas en la región confían en nosotros desde hace más de 18 años.
          </p>
          <a href="#cotizar" style={{ background: AZUL }}
            className="inline-block mt-6 hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
            QUIERO MI COTIZACIÓN →
          </a>
        </div>
      </section>

      {/* Trabajo real */}
      <section className="max-w-6xl mx-auto px-4 pb-14">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Nuestro equipo en acción</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Trabajo real, resultados <span style={{ color: AZUL }}>reales</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
          <figure className="rounded-2xl overflow-hidden border border-white/10 group relative">
            <img src={IMG.fotoEscalera} alt="Baranda de vidrio templado en balcón" className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent text-xs text-white/90 px-3 pt-8 pb-2 font-bold">Baranda de vidrio templado en balcón</figcaption>
          </figure>
          <figure className="rounded-2xl overflow-hidden border border-white/10 group relative">
            <img src={IMG.fotoVidrio} alt="Pasamanos instalado en escaleras" className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent text-xs text-white/90 px-3 pt-8 pb-2 font-bold">Pasamanos con vidrio templado en escaleras</figcaption>
          </figure>
        </div>
      </section>

      {/* Carrusel de proyectos (estilo Netflix) */}
      <section className="pb-14" data-testid="carrusel-proyectos">
        <div className="max-w-6xl mx-auto px-4">
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Inspírate</p>
          <h2 className="text-2xl sm:text-3xl font-black mb-6">Ideas para tu <span style={{ color: AZUL }}>proyecto</span></h2>
        </div>
        <LandingCarrusel producto="pasamanos_acero_inox" initial={[
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/n5syxk3n_8fc60cb8-0f8a-4565-9c23-0a151666e6d1.jpeg', caption: 'Escalera con baranda de vidrio y ventanal' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/if3cot96_7b3bb18e-7ca0-4c92-99d8-49753f92be08.jpeg', caption: 'Baranda de vidrio con doble pasamanos inox' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/73lqt0pe_06f35495-cef0-4f2b-9161-4863324bb1ef.jpeg', caption: 'Vidrio templado en escaleras de madera' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/ibmvvwgg_0e3894db-ce03-466b-b4d4-0a6a6474e646.jpeg', caption: 'Detalle de acabados en acero inoxidable' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/fmebccao_7e549f41-0d94-4025-a2f1-10724adb99d9.jpeg', caption: 'Baranda de barras horizontales en acero' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/au5hc3hg_3329efac-c997-46bc-8481-77d8e8bef021.jpeg', caption: 'Pasamanos para escaleras flotantes' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/3zmnookv_f6e12604-7d9f-4058-af3a-161e26030268.jpeg', caption: 'Baranda minimalista para espacios modernos' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/ijsv6pxf_fd4cea60-05b2-475c-9363-30955c8cc960.jpeg', caption: 'Balcón curvo con vidrio en exteriores', pos: 'object-top' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/rwd11ffe_ff1dda15-124b-4e7e-8ca2-8214fb1e2239.jpeg', caption: 'Pasamanos continuo en escaleras en L' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/70je2ph8_8f2c6471-b563-4585-992d-c4769a879556.jpeg', caption: 'Vidrio templado en doble altura' },
        ]} />
      </section>

      {/* Testimonios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-testimonios">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Lo que dicen nuestros clientes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Clientes que confiaron <span style={{ color: AZUL }}>en nosotros</span></h2>
        <LandingTestimonios producto="pasamanos_acero_inox" initial={[
            {
              nombre: 'Ana Lucía Morales',
              lugar: 'Ciudad de Guatemala',
              texto: 'Instalaron el pasamanos de las gradas de mi casa y quedó espectacular. El acero es de primera calidad y el acabado se nota que está soldado con precisión. Cumplieron la fecha de entrega tal como lo prometieron.',
            },
            {
              nombre: 'Roberto Castillo',
              lugar: 'Antigua Guatemala, Sacatepéquez',
              texto: 'Contratamos a Soluciones para las barandas de vidrio templado de nuestro hotel. Muy responsables: llegaron puntuales, protegieron el área de trabajo y dejaron todo limpio. Después de dos años, el acero sigue impecable.',
            },
            {
              nombre: 'María Fernanda López',
              lugar: 'Quetzaltenango',
              texto: 'Lo que más valoro es la confianza. Me asesoraron desde el diseño, me enviaron avances por WhatsApp y el precio fue justo por la calidad recibida. Sin duda los recomiendo, se nota la experiencia que tienen.',
            },
          ]} color={AZUL} />
      </section>

      {/* Cobertura */}
      <section className="border-y border-white/10 bg-white/[0.03]">
        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="font-black text-base sm:text-lg tracking-wide" style={{ color: AZUL }} data-testid="cobertura-paises">
            Guatemala · El Salvador · Honduras · Costa Rica
          </p>
          <p className="text-white/50 text-sm mt-1">Cobertura regional con instalación profesional</p>
        </div>
      </section>

      {/* Preguntas Frecuentes */}
      <section className="max-w-3xl mx-auto px-4 py-14" data-testid="seccion-faq">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Resolvemos tus dudas</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Preguntas <span style={{ color: AZUL }}>frecuentes</span></h2>
        <div className="space-y-3">
          {[
            ['¿Cuánto cuesta un pasamanos de acero inoxidable?',
              'Cada proyecto es único: el precio depende de los metros lineales, el diseño (recto, curvo, con vidrio templado) y la ubicación. Por eso la cotización es GRATIS y sin compromiso — envíanos las medidas o fotos por WhatsApp y te respondemos el mismo día.'],
            ['¿Cuánto tiempo tarda la fabricación e instalación?',
              'Dependiendo del tamaño del proyecto, la fabricación toma entre 1 y 3 semanas. La instalación se completa en 2 a 5 días, dependiendo de la cantidad de diseño y los metros lineales, con nuestro propio equipo profesional.'],
            ['¿El acero inoxidable requiere mantenimiento?',
              'Usamos acero inoxidable aleación 304, de la más alta calidad. La limpieza es con trapo seco (no húmedo). No aplicar cloro ni limpiadores que contengan químicos: usa líquidos especiales para limpiar y proteger acero inoxidable, y mantendrá su brillo por años.'],
            ['¿Trabajan fuera de la ciudad capital?',
              'Sí, cubrimos toda Guatemala y también El Salvador.'],
            ['¿Los materiales tienen garantía?',
              'Sí. Con más de 18 años de experiencia respaldamos la calidad de nuestros materiales y de la instalación. La garantía aplica media vez el acero se limpie con trapo seco y no se usen limpiadores que contengan químicos o cloro. Todos nuestros acabados son soldados e integrados en una sola pieza para máxima durabilidad.'],
            ['¿Cómo empiezo mi proyecto?',
              'Muy fácil: llena el formulario de esta página o escríbenos al WhatsApp 5430-7807. Te asesoramos desde el diseño hasta la instalación final.'],
          ].map(([q, a], i) => (
            <details key={q} className="group bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 font-bold text-sm sm:text-base list-none [&::-webkit-details-marker]:hidden hover:bg-white/[0.03] transition-colors">
                {q}
                <span style={{ color: AZUL }} className="text-xl font-black shrink-0 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="px-5 pb-5 text-white/65 text-sm leading-relaxed">{a}</p>
            </details>
          ))}
        </div>

        {/* Guía descargable */}
        <div className="mt-8 bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8 text-center" data-testid="seccion-guia">
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Regalo para tu proyecto</p>
          <h3 className="text-xl sm:text-2xl font-black">Guía de Cuidado del <span style={{ color: AZUL }}>Acero Inoxidable 304</span></h3>
          <p className="text-white/55 text-sm mt-2 max-w-lg mx-auto">
            Descarga gratis nuestra guía con los cuidados correctos para interior y exterior, y mantén tu pasamanos como nuevo por décadas.
          </p>
          <button type="button" onClick={() => window.open(`${API}/api/landing/guia-acero-304`, '_blank')} data-testid="btn-descargar-guia"
            style={{ background: AZUL }}
            className="inline-flex items-center gap-2 mt-5 hover:brightness-110 text-white font-black px-7 py-3 rounded-full text-sm transition-all">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            DESCARGAR GUÍA PDF
          </button>
        </div>
      </section>

      {/* Formulario */}
      <section id="cotizar" className="max-w-2xl mx-auto px-4 py-16">
        <div className="bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8">
          {done ? (
            <div className="text-center py-6" data-testid="lead-success">
              <p className="text-5xl mb-4">✅</p>
              <h3 className="text-2xl font-black">¡Recibido, {form.nombre.split(' ')[0]}!</h3>
              <p className="text-white/60 text-sm mt-2 mb-6">Un asesor te contactará muy pronto. Si quieres respuesta inmediata, continúa por WhatsApp:</p>
              <a href={done.wa_link} target="_blank" rel="noreferrer" data-testid="lead-wa-btn"
                className="inline-block bg-[#25D366] hover:brightness-110 text-white font-black px-8 py-3 rounded-full text-sm transition-all">
                💬 Continuar en WhatsApp
              </a>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-black">Cotiza <span style={{ color: AZUL }}>GRATIS</span> en 30 segundos</h2>
              <p className="text-white/50 text-sm mt-1 mb-6">Sin compromiso. Te contactamos por WhatsApp o llamada.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Tu nombre *</label>
                  <input value={form.nombre} onChange={set('nombre')} data-testid="lead-nombre" placeholder="Ej: Carlos Pérez"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Teléfono / WhatsApp *</label>
                  <input value={form.telefono} onChange={set('telefono')} data-testid="lead-telefono" placeholder="Ej: 5555 5555" inputMode="tel"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">¿En qué departamento estás? *</label>
                  <select value={form.departamento} onChange={set('departamento')} data-testid="lead-departamento" style={{ colorScheme: 'dark' }}
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors">
                    <option value="">Selecciona…</option>
                    {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Detalles de tu cotización</label>
                  <textarea value={form.detalles} onChange={set('detalles')} data-testid="lead-detalles" rows={3}
                    placeholder="Ej: pasamanos para gradas de 4 metros, con vidrio templado…"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors resize-none" />
                </div>
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  style={{ background: AZUL }}
                  className="w-full hover:brightness-110 disabled:opacity-60 text-white font-black py-3.5 rounded-xl text-sm transition-all">
                  {sending ? 'Enviando…' : 'QUIERO MI COTIZACIÓN GRATIS'}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        Soluciones Arquitectónicas · Grupo SACH · Guatemala · WhatsApp +502 5430 7807 · +18 años de experiencia
      </footer>

      {/* WhatsApp flotante */}
      <a href={waLink('¡Hola! Vi la página de pasamanos de acero inoxidable y quiero una cotización 😊')}
        target="_blank" rel="noreferrer" data-testid="wa-float-btn" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
